import React from 'react'
import MainContent from 'components/content'
import './style.scss'

type Props = {
  thead: any
  tbody: any
  className?: string
  toolbar?: React.ReactNode
  footer?: React.ReactNode
}

const Table = (props: Props) => {
  let classes = 'c-table'

  if (props.className) {
    classes += ' ' + props.className
  }

  return (
    <div className="c-table-wrapper">
      {props.toolbar && <div className="c-table-toolbar">{props.toolbar}</div>}
      <div className="c-table-inner-wrapper">
        <table className={classes}>
          <thead>{props.thead}</thead>
          <tbody>{props.tbody}</tbody>
        </table>
      </div>
      {props.footer && <div className="c-table-footer">{props.footer}</div>}
    </div>
  )
}

export default React.memo(Table)

interface ThProps {
  _id: string
  style?: Object
  children?: any
  onClick?: (_id: string) => void
  className?: string
}

export const Th = React.memo(
  (props: ThProps) => {
    let classes = 'c-table__th'

    if (props.onClick) {
      classes += ' s-pointer'
    }

    if (props.className) {
      classes += ' ' + props.className
    }

    return (
      <th
        className={classes}
        style={props.style}
        onClick={() => {
          props.onClick && props.onClick(props._id)
        }}
      >
        <div>{props.children}</div>
      </th>
    )
  },
  () => false
)

interface TDProps {
  style?: Object
  children?: any
  onClick?: () => void
  colSpan?: number
  className?: string
  contentPosition?: 'middle'
}

export const Td = (props: TDProps) => {
  let divClasses = 'c-table-td-div'

  if (props.contentPosition) {
    divClasses += ' s-content-middle'
  }

  return (
    <td
      className={props.className}
      colSpan={props.colSpan || 1}
      onClick={() => {
        props.onClick && props.onClick()
      }}
      style={props.style}
    >
      <div className={divClasses} style={props.style}>
        {props.children}
      </div>
    </td>
  )
}

export const Tr = ({
  children,
  style,
  className,
  disableOddStyle,
  onClick,
  showHover,
  selected
}: {
  children: any
  style?: object
  className?: string
  disableOddStyle?: boolean
  showHover?: boolean
  onClick?: () => void
  selected?: boolean
}) => {
  let classes = 'c-table-tr'

  if (disableOddStyle) {
    classes += 's-disable-odd-style'
  }

  if (onClick) classes += ' s-hover'

  if (selected) {
    classes += ' s-selected'
  }

  if (showHover) {
    classes += ' s-hover'
  }

  if (className) {
    classes += ' ' + className
  }

  return (
    <tr style={style ? style : {}} className={classes} onClick={() => onClick && onClick()}>
      {children}
    </tr>
  )
}
